(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'emotion', '../../styles/colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('emotion'), require('../../styles/colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.emotion, global.colors);
    global.NotificationBoxVariantCss = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _emotion, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    padding: 0 0 0 16px;\n    border-radius: 3px;\n    width: 100%;\n\n    &.notifysuccess {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifyerror {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifyinfo {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifywarn {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n  '], ['\n    padding: 0 0 0 16px;\n    border-radius: 3px;\n    width: 100%;\n\n    &.notifysuccess {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifyerror {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifyinfo {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n\n    &.notifywarn {\n      background-color: ', ';\n      border: 1px solid ', ';\n      color: ', ';\n    }\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    vertical-align: 3px;\n  '], ['\n    vertical-align: 3px;\n  ']);

  var NotificationBoxVariantStyles = {
    notificationVariant: (0, _emotion.css)(_templateObject, _colors2.default.mint, _colors2.default.jungle, _colors2.default.prussian, _colors2.default.rose, _colors2.default.dragon, _colors2.default.dragon, _colors2.default.lightPrussian, _colors2.default.prussian, _colors2.default.prussian, _colors2.default.blonde, _colors2.default.soil, _colors2.default.soil),
    verticalAlign: (0, _emotion.css)(_templateObject2)
  };

  exports.default = NotificationBoxVariantStyles;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Notifications/NotificationBoxVariant.css.js
// module id = 1938
// module chunks = 1